/**
 * Summary Content Component
 */

import { formatSummaryContent } from '../ConversationSummary.functions';

export type TSummaryContentProps = {
  content: string;
};

export default function SummaryContent(props: TSummaryContentProps) {
  return (
    <div
      className="prose prose-sm max-w-none text-gray-700 leading-relaxed"
      dangerouslySetInnerHTML={{ __html: formatSummaryContent(props.content) }}
    />
  );
}
